import React, { useState } from 'react';
import './pagestyles/TerminalDemo.css';

const TerminalDemo = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    jobTitle: '',
    country: '',
    interests: [],
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      interests: checked 
        ? [...prev.interests, value]
        : prev.interests.filter(item => item !== value)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your interest! Our team will contact you shortly.');
    // Here you would typically send the data to your backend
  };

  return (
    <div className="page-container">
      <div className="container">
        <div className="demo-request-page">
          <div className="demo-header">
            <h1>Request a Redbox Global Terminal Demo</h1>
            <p className="demo-subtitle">
              Experience the power of real-time financial data, analytics, and trading tools. 
              Fill out the form below and our team will contact you to schedule a personalized demonstration.
            </p>
          </div>

          <div className="demo-benefits-centered">
            <h2>Why Choose Redbox Terminal?</h2>
            <ul className="benefits-list-grid">
              <li>
                <strong>Real-Time Market Data</strong>
                <p>Access live quotes, news, and analytics from global markets</p>
              </li>
              <li>
                <strong>Advanced Analytics</strong>
                <p>Powerful charting tools and financial modeling capabilities</p>
              </li>
              <li>
                <strong>Trading Integration</strong>
                <p>Seamless execution across multiple asset classes</p>
              </li>
              <li>
                <strong>News & Research</strong>
                <p>Comprehensive coverage from trusted sources worldwide</p>
              </li>
              <li>
                <strong>Customizable Workspace</strong>
                <p>Tailor your terminal to match your workflow</p>
              </li>
              <li>
                <strong>24/7 Support</strong>
                <p>Expert assistance whenever you need it</p>
              </li>
            </ul>
          </div>

          <div className="demo-form-section">
            <div className="demo-form-container">
              <form className="demo-form" onSubmit={handleSubmit}>
                <h2>Contact Information</h2>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">First Name *</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">Last Name *</label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="email">Business Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="company">Company *</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="jobTitle">Job Title *</label>
                  <input
                    type="text"
                    id="jobTitle"
                    name="jobTitle"
                    value={formData.jobTitle}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="country">Country *</label>
                  <select
                    id="country"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a country</option>
                    <option value="US">United States</option>
                    <option value="UK">United Kingdom</option>
                    <option value="SG">Singapore</option>
                    <option value="JP">Japan</option>
                    <option value="CN">China</option>
                    <option value="HK">Hong Kong</option>
                    <option value="IN">India</option>
                    <option value="AU">Australia</option>
                    <option value="OTHER">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Areas of Interest</label>
                  <div className="checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        value="equities"
                        onChange={handleCheckboxChange}
                      />
                      Equities
                    </label>
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        value="fixed-income"
                        onChange={handleCheckboxChange}
                      />
                      Fixed Income
                    </label>
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        value="currencies"
                        onChange={handleCheckboxChange}
                      />
                      Currencies
                    </label>
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        value="commodities"
                        onChange={handleCheckboxChange}
                      />
                      Commodities
                    </label>
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        value="derivatives"
                        onChange={handleCheckboxChange}
                      />
                      Derivatives
                    </label>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Additional Information</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Tell us about your specific needs and preferences..."
                  />
                </div>

                <button type="submit" className="submit-btn">
                  Request Demo
                </button>

                <p className="form-disclaimer">
                  By submitting this form, you agree to our Terms of Service and Privacy Policy. 
                  We will use your information to contact you about our products and services.
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerminalDemo;
